import { takeEvery } from 'redux-saga'
import { put, select } from 'redux-saga/effects'
import { updateUiAction } from 'actions/uiActions'
import { currentCameraSelector, uiSelector } from 'selectors'
import { updateCameraAction, SET_CAMERA_MODEL, addRecentModelAction } from 'actions/cameraActions'
import { updatePresentationValuesAction } from 'actions/presentationActions'

export function * setCameraConfiguration(action) {
  const { currentCamera: { id } } = yield select(currentCameraSelector)
  const { model, aov } = action

  yield put(updateUiAction({ modal: null }))
  yield put(updateCameraAction('model', { model, aov }, id))
  yield put(updatePresentationValuesAction())
  yield put(addRecentModelAction(model.id, Date.now()))
}

export function * watchSetCameraConfiguration() {
  yield * takeEvery(SET_CAMERA_MODEL, setCameraConfiguration)
}



// WEBPACK FOOTER //
// ./src/sagas/setCameraModelSaga.js